(function () {
  'use strict';

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    revealEls.forEach(function (el) {
      var delay = el.getAttribute('data-reveal-delay');
      if (delay) el.style.setProperty('--reveal-delay', delay);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Header scroll state (border/backdrop only — header always stays visible, matches the approved mockup) ---------- */
  var header = document.getElementById('SiteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  var toggle = document.getElementById('MobileNavToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Hero product cluster: desktop float/tilt + mobile swipeable "wheel" ---------- */
  document.querySelectorAll('[data-hero-cluster]').forEach(function (root) {
    var stage = root.querySelector('[data-orbit-stage]');
    var visual = root.querySelector('[data-hero-visual]');
    if (!stage || !visual) return;

    var isMobileView = function () { return window.matchMedia('(max-width:900px)').matches; };

    visual.addEventListener('mousemove', function (e) {
      if (isMobileView()) return;
      var r = visual.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      stage.style.transform = 'translate(' + (x * 18) + 'px, ' + (y * 14) + 'px)';
    });
    visual.addEventListener('mouseleave', function () { stage.style.transform = ''; });

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-orbit-item]'));
    if (!items.length) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-wheel-dot]'));
    var order = items.map(function (_, i) { return i; });
    if (order.length === 3) { order = [order[1], order[0], order[2]]; }

    var applySlots = function () {
      var slots = ['left', 'center', 'right'];
      order.forEach(function (itemIdx, slotIdx) {
        if (items[itemIdx]) items[itemIdx].dataset.slot = slots[slotIdx];
      });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === order[1]); });
    };
    applySlots();

    var rotate = function (dir) {
      if (dir === 1) { order.push(order.shift()); } else { order.unshift(order.pop()); }
      applySlots();
    };

    var touchStartX = null;
    stage.addEventListener('touchstart', function (e) {
      if (!isMobileView()) return;
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!isMobileView() || touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) rotate(dx < 0 ? 1 : -1);
      touchStartX = null;
    }, { passive: true });

    items.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (!isMobileView()) return;
        if (el.dataset.slot !== 'center') {
          e.preventDefault();
          rotate(el.dataset.slot === 'left' ? -1 : 1);
        }
      });
    });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var guard = 0;
        while (order[1] !== i && guard < 3) { rotate(1); guard++; }
      });
    });
  });

  /* ---------- Swipe row (usata da "Completa il look" e da "Recensioni"): sincronizza pallini
     e/o freccette di navigazione con la posizione di scroll nativo (scroll-snap, vedi CSS).
     Quale card è "attiva" si calcola trovando la card il cui centro è più vicino al centro del
     contenitore ad ogni scroll (throttled via requestAnimationFrame). Preferito a un
     IntersectionObserver a soglia fissa: con card larghe una frazione del contenitore può capitare
     che due card superino la soglia di visibilità nello stesso istante, facendo accendere il
     pallino sbagliato — il criterio "più vicina al centro" è sempre inequivocabile. Su mobile lo
     swipe è nativo (nessuna gestione manuale del touch, più fluido e senza conflitti con lo scroll
     verticale della pagina); le freccette (quando presenti, es. su desktop) chiamano la stessa
     funzione di scorrimento verso la card successiva/precedente.

     Due modalità:
     - "clamp" (default, usata da "Completa il look"): si ferma ai due estremi, le freccette si
       disabilitano quando non c'è più nulla da scorrere.
     - "loop" (usata da "Recensioni", attivata con [data-swipe-grid-loop]): non ci si blocca MAI,
       in nessuno dei due versi — swipe col dito, trackpad, rotellina o frecce, avanti e indietro,
       all'infinito. In Liquid le card reali vengono renderizzate 5 volte in fila (due copie
       cuscinetto, la copia reale editabile dal tema editor al centro, altre due copie cuscinetto
       dopo — vedi sections/reviews.liquid). Si parte sempre dal blocco centrale. Quando lo scroll
       (di qualunque origine: dito, trackpad, frecce) entra in uno dei blocchi cuscinetto, e SOLO a
       scroll fermo (mai a metà di un gesto attivo, altrimenti si vedrebbe uno scatto), lo si
       riporta indietro/avanti di esattamente un blocco nella direzione opposta. L'offset non si
       calcola dividendo la larghezza totale per il numero di copie (impreciso per via degli
       arrotondamenti subpixel, causa di piccoli scatti visibili) ma misurando la distanza reale in
       pixel tra due blocchi identici, quindi il riposizionamento atterra sempre esattamente su un
       punto di snap valido e non si vede alcun salto. Il cuscinetto è largo due blocchi per lato
       (non uno solo) apposta: uno swipe deciso può scorrere più di una card in un colpo solo, e con
       un solo blocco di margine si rischierebbe di uscire dall'array prima che la correzione abbia
       il tempo di scattare. */
  document.querySelectorAll('[data-swipe-grid]').forEach(function (grid) {
    var cards = Array.prototype.slice.call(grid.children);
    if (!cards.length) return;

    /* Blocco esplicito dello swipe verticale: lo swipe su questi caroselli deve essere
       ESCLUSIVAMENTE orizzontale, mai verso l'alto/basso. touch-action: pan-x (vedi CSS) da
       solo dovrebbe già bastare, ma il supporto browser a questa proprietà non è sempre
       affidabile al 100% (in particolare su alcune versioni di Safari) — qui la blocchiamo
       anche via JS, in modo esplicito e a prova di browser: si registra la posizione del
       dito al tocco, e al primo movimento sufficientemente ampio si decide una sola volta la
       direzione del gesto (quella dominante tra dx e dy). Se il gesto è verticale, si chiama
       preventDefault sul touchmove: questo blocca DEL TUTTO lo scroll verticale della pagina
       per quel gesto (non solo dentro il carosello), esattamente come richiesto — "solo
       destra/sinistra, niente su/giù". Se invece il gesto è orizzontale, non si fa nulla e si
       lascia lo scroll nativo del browser gestire il movimento (più fluido, con inerzia) —
       non va mai chiamato preventDefault in quel caso, altrimenti si disabiliterebbe anche lo
       scroll orizzontale nativo che si vuole invece mantenere. */
    var touchStartX = 0, touchStartY = 0, touchAxis = null;
    grid.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchAxis = null;
    }, { passive: true });
    grid.addEventListener('touchmove', function (e) {
      if (!e.touches.length) return;
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (touchAxis === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; /* movimento troppo piccolo per capire la direzione */
        touchAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (touchAxis === 'y') e.preventDefault();
    }, { passive: false });
    grid.addEventListener('touchend', function () { touchAxis = null; }, { passive: true });
    grid.addEventListener('touchcancel', function () { touchAxis = null; }, { passive: true });

    var dotsWrap = grid.parentElement.querySelector('[data-grid-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-grid-dot]')) : [];
    var navWrap = grid.parentElement.querySelector('[data-grid-nav]');
    var prevBtn = navWrap ? navWrap.querySelector('[data-grid-prev]') : null;
    var nextBtn = navWrap ? navWrap.querySelector('[data-grid-next]') : null;
    if (!dots.length && !prevBtn && !nextBtn) return; /* niente da sincronizzare: lo scroll-snap nativo funziona comunque da solo */

    var currentIdx = 0;

    var scrollToIndex = function (idx) {
      var card = cards[idx];
      if (!card) return;
      var startLeft = grid.scrollLeft;
      var left = card.getBoundingClientRect().left - grid.getBoundingClientRect().left + startLeft;
      grid.scrollTo({ left: left, behavior: 'smooth' });
      /* Rete di sicurezza: in alcuni contesti (impostazioni "riduci animazioni", tab in
         background) uno scrollTo smooth dentro un contenitore con scroll-snap può non
         animare mai. Se dopo un attimo non si è mosso, si forza un salto istantaneo così
         il controllo funziona comunque sempre. */
      window.setTimeout(function () {
        if (left !== startLeft && Math.round(grid.scrollLeft) === Math.round(startLeft)) {
          grid.scrollTo({ left: left, behavior: 'instant' });
        }
      }, 450);
    };

    var setActiveDot = function (realIdx) {
      dots.forEach(function (d, i) { d.classList.toggle('active', i === realIdx); });
    };

    if (grid.hasAttribute('data-swipe-grid-loop')) {
      var groupSize = parseInt(grid.getAttribute('data-real-count'), 10) || Math.round(cards.length / 5);
      /* 5 blocchi in fila (vedi sections/reviews.liquid): cuscinetto, cuscinetto, REALE, cuscinetto,
         cuscinetto. Il blocco reale (quello editabile dal tema editor) è il blocco numero 2 (0-based),
         quindi occupa l'intervallo di indici [2*groupSize, 3*groupSize). Si parte sempre lì. */
      var homeStart = groupSize * 2;
      var homeEnd = groupSize * 3;

      /* Offset esatto (in pixel) di un intero blocco, ricalcolato ogni volta da positionHome
         misurando la posizione reale delle card — non calcolato dividendo la larghezza totale
         per il numero di blocchi, che con gli arrotondamenti subpixel può risultare leggermente
         impreciso e causare scatti visibili. */
      var blockOffset = 0;

      /* Posizionamento iniziale istantaneo (nessuna animazione) sulla prima card del blocco
         reale: esattamente quella che si vede nell'editor. Chiamata più volte (subito, poi al
         frame successivo, poi con un piccolo margine di sicurezza) perché al primissimo giro il
         layout della pagina potrebbe non essere ancora definitivo (font non ancora applicati,
         reflow in corso): un'unica lettura sincrona può risultare imprecisa, e senza questa
         doppia conferma il carosello può ripartire dal primo blocco cuscinetto invece che da
         quello reale — che è esattamente ciò che rendeva impossibile scorrere all'indietro.

         IMPORTANTE: qui NON si usa mai l'assegnazione diretta `grid.scrollLeft = ...`. Su un
         contenitore con scroll-snap attivo, Chrome può rifiutare silenziosamente quella scrittura
         (la proprietà torna a leggere il vecchio valore, come se non fosse mai stata cambiata) —
         è esattamente questo, e non un problema di timing, il motivo per cui il carosello restava
         bloccato al primo blocco cuscinetto anche con i tentativi precedenti. `scrollTo({..,
         behavior:'instant'})` invece funziona sempre in modo affidabile su questo tipo di
         contenitore, quindi è l'unico metodo usato per riposizionare lo scroll in questo file. */
      var positionHome = function () {
        var homeCard = cards[homeStart];
        var afterCard = cards[homeEnd];
        blockOffset = afterCard.getBoundingClientRect().left - homeCard.getBoundingClientRect().left;
        var target = homeCard.getBoundingClientRect().left - grid.getBoundingClientRect().left + grid.scrollLeft;
        grid.scrollTo({ left: target, behavior: 'instant' });
        currentIdx = homeStart;
      };
      positionHome();
      window.requestAnimationFrame(function () {
        positionHome();
        window.requestAnimationFrame(positionHome);
      });
      window.setTimeout(positionHome, 200);

      /* Le freccette prev/next NON devono basarsi su currentIdx (la card "centrale", usata solo
         per accendere il pallino giusto): quando più di una card è visibile insieme (es. 3 card
         affiancate su desktop), la card centrale è sempre un indice avanti rispetto alla card
         "di partenza" (quella il cui bordo sinistro coincide con grid.scrollLeft, cioè quella
         effettivamente usata da scrollToIndex per calcolare la destinazione). Usare currentIdx-1
         come bersaglio della freccetta "prev" finisce quindi per ricalcolare la posizione GIÀ
         corrente (nessuno scatto visibile, la freccetta sembra non fare nulla). Qui si ricalcola
         invece, al momento del click, quale card ha davvero il bordo sinistro più vicino a
         grid.scrollLeft — quella è la vera "card di partenza" — e ci si sposta di uno rispetto a
         quella, sempre, indipendentemente da quante card sono visibili insieme. */
      var getAlignedIdx = function () {
        var gridRect = grid.getBoundingClientRect();
        var best = currentIdx, bestDist = Infinity;
        cards.forEach(function (card, i) {
          var left = card.getBoundingClientRect().left - gridRect.left + grid.scrollLeft;
          var dist = Math.abs(left - grid.scrollLeft);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        return best;
      };

      var wrapTimer = null;
      var checkWrap = function () {
        var guard = 0;
        var pos = grid.scrollLeft;
        while (currentIdx >= homeEnd && guard < 6) {
          pos -= blockOffset;
          currentIdx -= groupSize;
          guard++;
        }
        while (currentIdx < homeStart && guard < 12) {
          pos += blockOffset;
          currentIdx += groupSize;
          guard++;
        }
        /* Come in positionHome: mai `grid.scrollLeft = ...` diretto, sempre scrollTo istantaneo
           — è l'unico modo che funziona in modo affidabile su questo contenitore con scroll-snap. */
        if (guard > 0) grid.scrollTo({ left: pos, behavior: 'instant' });
        setActiveDot(((currentIdx - homeStart) % groupSize + groupSize) % groupSize);
      };

      var tickingLoop = false;
      var updateFromScrollLoop = function () {
        tickingLoop = false;
        var gridRect = grid.getBoundingClientRect();
        var gridCenter = gridRect.left + gridRect.width / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var cardCenter = r.left + r.width / 2;
          var dist = Math.abs(cardCenter - gridCenter);
          if (dist < closestDist) { closestDist = dist; closestIdx = i; }
        });
        currentIdx = closestIdx;
        setActiveDot(((currentIdx - homeStart) % groupSize + groupSize) % groupSize);
      };
      updateFromScrollLoop();

      grid.addEventListener('scroll', function () {
        if (!tickingLoop) {
          tickingLoop = true;
          window.requestAnimationFrame(updateFromScrollLoop);
        }
        /* La correzione (checkWrap) si applica solo a scroll fermo, mai durante un gesto attivo
           (dito ancora sullo schermo, o inerzia del momentum scroll in corso): farla a metà di un
           movimento si vedrebbe come uno scatto — esattamente quello che va evitato. Funziona
           indipendentemente dall'origine dello scroll: swipe col dito, trackpad, rotellina o le
           frecce sotto (che a loro volta scrollano via scrollToIndex), perché ascolta l'evento
           'scroll' nativo del contenitore, non un gesto specifico. */
        window.clearTimeout(wrapTimer);
        wrapTimer = window.setTimeout(checkWrap, 150);
      }, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { scrollToIndex(homeStart + i); });
      });
      /* Le freccette restano sempre attive in entrambi i sensi: non c'è mai un "fondo" da
         raggiungere, né in avanti né indietro — dopo l'ultima recensione si riparte dalla prima e
         viceversa, all'infinito. */
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(getAlignedIdx() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(getAlignedIdx() + 1); });
    } else {
      var setActive = function (idx) {
        currentIdx = idx;
        setActiveDot(idx);
      };

      var updateNavState = function () {
        if (!prevBtn && !nextBtn) return;
        var maxScroll = grid.scrollWidth - grid.clientWidth - 1;
        if (prevBtn) prevBtn.disabled = grid.scrollLeft <= 0;
        if (nextBtn) nextBtn.disabled = grid.scrollLeft >= maxScroll;
      };

      var ticking = false;
      var updateFromScroll = function () {
        ticking = false;
        var gridRect = grid.getBoundingClientRect();
        var gridCenter = gridRect.left + gridRect.width / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var cardCenter = r.left + r.width / 2;
          var dist = Math.abs(cardCenter - gridCenter);
          if (dist < closestDist) { closestDist = dist; closestIdx = i; }
        });
        setActive(closestIdx);
        updateNavState();
      };
      updateFromScroll();

      grid.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateFromScroll);
        }
      }, { passive: true });

      /* Stesso ragionamento del carosello a loop qui sopra: le freccette devono muoversi
         rispetto alla card "di partenza" (bordo sinistro allineato a grid.scrollLeft), non
         rispetto a currentIdx (la card centrale) — altrimenti quando più di una card è visibile
         insieme (desktop) la freccetta può ricalcolare la posizione già corrente e sembrare
         non fare nulla. */
      var getAlignedIdxClamp = function () {
        var gridRect = grid.getBoundingClientRect();
        var best = currentIdx, bestDist = Infinity;
        cards.forEach(function (card, i) {
          var left = card.getBoundingClientRect().left - gridRect.left + grid.scrollLeft;
          var dist = Math.abs(left - grid.scrollLeft);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        return best;
      };

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { scrollToIndex(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(Math.max(0, Math.min(cards.length - 1, getAlignedIdxClamp() - 1))); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(Math.max(0, Math.min(cards.length - 1, getAlignedIdxClamp() + 1))); });
    }
  });

  /* ---------- Product gallery: thumbnails + arrows + swipe ---------- */
  var mainImg = document.getElementById('ProductMainImage');
  var galleryMain = document.getElementById('ProductGalleryMain');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__thumb'));
  if (mainImg && thumbs.length) {
    var currentIndex = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    if (currentIndex < 0) currentIndex = 0;

    var showImage = function (index) {
      var count = thumbs.length;
      currentIndex = (index + count) % count;
      var thumb = thumbs[currentIndex];
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      mainImg.src = thumb.getAttribute('data-full');
      if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showImage(i); });
    });

    var prevBtn = document.querySelector('.product-gallery__arrow--prev');
    var nextBtn = document.querySelector('.product-gallery__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

    if (galleryMain) {
      var touchStartX2 = 0;
      var touchStartY2 = 0;
      galleryMain.addEventListener('touchstart', function (e) {
        touchStartX2 = e.changedTouches[0].clientX;
        touchStartY2 = e.changedTouches[0].clientY;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX2;
        var dy = e.changedTouches[0].clientY - touchStartY2;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) { showImage(currentIndex + 1); } else { showImage(currentIndex - 1); }
        }
      }, { passive: true });
    }
  }

  /* ---------- Product image lightbox: click to open, pinch/wheel/double-tap/drag to zoom & pan ----------
     Built with the Pointer Events API so the same code handles mouse (desktop) and touch (mobile)
     without two separate code paths: pointerdown/move/up fire identically for both input types. */
  (function () {
    var lightbox = document.getElementById('ProductLightbox');
    var stage = document.getElementById('ProductLightboxStage');
    var lbImg = document.getElementById('ProductLightboxImage');
    var closeBtn = document.getElementById('ProductLightboxClose');
    var prevBtn = document.getElementById('ProductLightboxPrev');
    var nextBtn = document.getElementById('ProductLightboxNext');
    if (!lightbox || !stage || !lbImg || !galleryMain || !mainImg) return;

    var lbThumbs = thumbs; /* reuse the gallery thumbs collected above, may be empty for single-image products */
    var lbIndex = 0;
    var scale = 1, minScale = 1, maxScale = 4;
    var tx = 0, ty = 0;

    var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

    var applyTransform = function () {
      lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      stage.classList.toggle('is-zoomed', scale > 1);
    };

    var resetView = function () { scale = 1; tx = 0; ty = 0; applyTransform(); };

    var loadIndex = function (index) {
      if (!lbThumbs.length) {
        lbImg.src = galleryMain.getAttribute('data-hd') || mainImg.src;
        return;
      }
      lbIndex = (index + lbThumbs.length) % lbThumbs.length;
      var thumb = lbThumbs[lbIndex];
      lbImg.src = thumb.getAttribute('data-hd') || thumb.getAttribute('data-full');
    };

    var open = function () {
      var activeIdx = lbThumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      loadIndex(activeIdx < 0 ? 0 : activeIdx);
      resetView();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lightbox-open');
    };

    var close = function () {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-open');
      resetView();
    };

    galleryMain.addEventListener('click', function (e) {
      if (e.target.closest('.product-gallery__arrow')) return;
      open();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') { loadIndex(lbIndex - 1); resetView(); }
      if (e.key === 'ArrowRight') { loadIndex(lbIndex + 1); resetView(); }
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { loadIndex(lbIndex - 1); resetView(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { loadIndex(lbIndex + 1); resetView(); });

    /* desktop: mouse wheel zooms, double-click toggles zoom */
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta = e.deltaY < 0 ? 0.35 : -0.35;
      scale = clamp(scale + delta, minScale, maxScale);
      if (scale === 1) { tx = 0; ty = 0; }
      applyTransform();
    }, { passive: false });

    stage.addEventListener('dblclick', function () {
      if (scale > 1) { scale = 1; tx = 0; ty = 0; } else { scale = 2.4; }
      applyTransform();
    });

    /* mobile + desktop: pinch to zoom (2 pointers), drag to pan when zoomed, double-tap to zoom */
    var pointers = {};
    var startDist = 0, startScale = 1;
    var dragging = false, dragStart = null;
    var lastTap = 0;

    var getDistance = function () {
      var pts = Object.keys(pointers).map(function (k) { return pointers[k]; });
      if (pts.length < 2) return 0;
      var dx = pts[0].x - pts[1].x, dy = pts[0].y - pts[1].y;
      return Math.sqrt(dx * dx + dy * dy);
    };

    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var count = Object.keys(pointers).length;
      if (count === 2) {
        startDist = getDistance();
        startScale = scale;
        dragging = false;
      } else if (count === 1 && scale > 1) {
        dragging = true;
        dragStart = { x: e.clientX - tx, y: e.clientY - ty };
        stage.classList.add('is-panning');
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var count = Object.keys(pointers).length;
      if (count === 2) {
        var dist = getDistance();
        if (startDist > 0) {
          scale = clamp(startScale * (dist / startDist), minScale, maxScale);
          applyTransform();
        }
      } else if (count === 1 && dragging) {
        tx = e.clientX - dragStart.x;
        ty = e.clientY - dragStart.y;
        applyTransform();
      }
    });

    var endPointer = function (e) {
      delete pointers[e.pointerId];
      var count = Object.keys(pointers).length;
      if (count < 2) startDist = 0;
      if (count === 0) {
        if (dragging) {
          dragging = false;
          stage.classList.remove('is-panning');
        } else if (e.pointerType === 'touch') {
          var now = Date.now();
          if (now - lastTap < 300) {
            if (scale > 1) { scale = 1; tx = 0; ty = 0; } else { scale = 2.4; }
            applyTransform();
          }
          lastTap = now;
        }
        if (scale <= 1) { scale = 1; tx = 0; ty = 0; applyTransform(); }
      }
    };
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
  })();

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll('.quantity-stepper__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = btn.closest('.quantity-stepper');
      var input = wrapper.querySelector('input[type="number"]');
      var step = parseInt(btn.getAttribute('data-step'), 10);
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var next = (parseInt(input.value, 10) || 1) + step;
      input.value = Math.max(min, next);
    });
  });

  /* ---------- Product option pills -> hidden select -> variant id ---------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var variantSelect = document.getElementById('ProductVariantSelect');
    var pills = productForm.querySelectorAll('.option-pill');
    var selections = {};

    pills.forEach(function (pill) {
      var idx = pill.getAttribute('data-option-index');
      if (pill.classList.contains('is-selected')) selections[idx] = pill.getAttribute('data-value');
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.getAttribute('data-option-index');
        productForm.querySelectorAll('.option-pill[data-option-index="' + idx + '"]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        selections[idx] = pill.getAttribute('data-value');

        if (variantSelect) {
          var values = Object.keys(selections).sort().map(function (k) { return selections[k]; });
          var match = Array.from(variantSelect.options).find(function (opt) {
            return values.every(function (v) { return opt.textContent.indexOf(v) !== -1; });
          });
          if (match) variantSelect.value = match.value;
        }
      });
    });
  }

  /* ---------- Judge.me: headline personalizzato al posto di quello di default dell'app ----------
     "Recensioni Clienti" è il titolo generato dall'app, non modificabile dalle impostazioni del
     blocco — l'unico modo per cambiarlo è nasconderlo via JS e mettere al suo posto un titolo
     scritto nello stile del sito (stesse classi .kicker/.section-heading usate ovunque). Il
     widget carica in modo asincrono (script esterno Judge.me), quindi non è detto sia già nel DOM
     quando questo file gira: si osserva il documento finché non compare, si applica una sola
     volta, poi ci si stacca.
     Judge.me usa layout diversi per l'header a seconda del widget ("standard" o "minimal"), con
     classi diverse per il titolo (rispettivamente .jm-review-widget-header__title e
     .jm-review-widget-minimal-header__title) — si intercettano entrambe così il fix regge anche
     se Judge.me cambia variante in futuro. */
  (function () {
    var applied = false;
    var apply = function (widget) {
      var defaultTitle = widget.querySelector('.jm-review-widget-header__title, .jm-review-widget-minimal-header__title');
      if (!defaultTitle || applied) return;
      applied = true;
      defaultTitle.style.display = 'none';
      var heading = document.createElement('div');
      heading.style.textAlign = 'center';
      heading.style.marginBottom = '10px';
      heading.innerHTML =
        '<span class="kicker">RECENSIONI VERIFICATE</span>' +
        '<h2 class="section-heading" style="margin:0;">Cosa dicono i nostri clienti</h2>';
      defaultTitle.parentNode.insertBefore(heading, defaultTitle);
    };

    var existing = document.querySelector('.jdgm-widget');
    if (existing) apply(existing);

    if (!applied) {
      var mo = new MutationObserver(function () {
        if (applied) { mo.disconnect(); return; }
        var w = document.querySelector('.jdgm-widget');
        if (w) {
          apply(w);
          if (applied) mo.disconnect();
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { mo.disconnect(); }, 15000);
    }
  })();
})();
